import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {},
  header: {
    padding: theme.spacing(1, 2),
  },

  card: {
    backgroundColor: theme.palette.background.paper,
    borderBottom: `${theme.spacing(0.125)} solid ${theme.palette.divider}`,
    borderTop: `${theme.spacing(0.125)} solid ${theme.palette.divider}`,
  },
}));
